import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7334 13.4426C11.4424 13.4426 11.2065 13.2068 11.2065 12.9158V8.65721C11.2065 6.8841 9.76412 5.44169 7.99101 5.44169C6.2179 5.44169 4.77549 6.8841 4.77549 8.65721V12.9158C4.77549 13.2068 4.53963 13.4426 4.24862 13.4426C3.95761 13.4426 3.72174 13.2068 3.72174 12.9158V8.65721C3.72174 6.30313 5.63693 4.38794 7.99101 4.38794C10.3449 4.38794 12.2603 6.30313 12.2603 8.65721V12.9158C12.2603 13.2068 12.0244 13.4426 11.7334 13.4426Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0973 15.8364H2.88455C2.27881 15.8364 1.78601 15.3436 1.78601 14.7379V13.4874C1.78601 12.8817 2.27881 12.3889 2.88455 12.3889H13.0973C13.703 12.3889 14.196 12.8817 14.196 13.4874V14.7379C14.196 15.3436 13.703 15.8364 13.0973 15.8364ZM2.88455 13.4427C2.85978 13.4427 2.83976 13.4627 2.83976 13.4874V14.7379C2.83976 14.7627 2.85996 14.7827 2.88455 14.7827H13.0973C13.1221 14.7827 13.1423 14.7627 13.1423 14.7379V13.4874C13.1423 13.4627 13.1221 13.4427 13.0973 13.4427H2.88455Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.66803 9.50765C9.37702 9.50765 9.14115 9.27178 9.14115 8.98077C9.14115 8.34659 8.62517 7.83061 7.99099 7.83061C7.69998 7.83061 7.46411 7.59474 7.46411 7.30373C7.46411 7.01272 7.69998 6.77686 7.99099 6.77686C9.20631 6.77686 10.1949 7.76545 10.1949 8.98077C10.1949 9.27178 9.95904 9.50765 9.66803 9.50765Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.74 8.57548H0.614766C0.323755 8.57548 0.0878906 8.33961 0.0878906 8.0486C0.0878906 7.75759 0.323755 7.52173 0.614766 7.52173H2.74C3.03101 7.52173 3.26688 7.75759 3.26688 8.0486C3.26688 8.33961 3.03101 8.57548 2.74 8.57548Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3673 8.57548H13.2418C12.9508 8.57548 12.715 8.33961 12.715 8.0486C12.715 7.75759 12.9508 7.52173 13.2418 7.52173H15.3673C15.6583 7.52173 15.8941 7.75759 15.8941 8.0486C15.8941 8.33961 15.6583 8.57548 15.3673 8.57548Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99099 3.32474C7.69998 3.32474 7.46411 3.08888 7.46411 2.79786V0.672627C7.46411 0.381616 7.69998 0.145752 7.99099 0.145752C8.282 0.145752 8.51786 0.381616 8.51786 0.672627V2.79786C8.51786 3.0887 8.282 3.32474 7.99099 3.32474Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.27793 4.86266C4.14305 4.86266 4.00817 4.8112 3.90543 4.70846L2.4026 3.20564C2.19677 2.99981 2.19677 2.66629 2.4026 2.46046C2.60844 2.25463 2.94212 2.2548 3.14778 2.46046L4.6506 3.96328C4.85644 4.16912 4.85644 4.50263 4.6506 4.70846C4.54769 4.8112 4.41281 4.86266 4.27793 4.86266Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7041 4.86273C11.5692 4.86273 11.4345 4.81127 11.3316 4.70835C11.1257 4.50269 11.1257 4.16901 11.3316 3.96335L12.8344 2.46053C13.0402 2.25469 13.3736 2.25469 13.5794 2.46053C13.7852 2.66618 13.7852 2.99987 13.5794 3.20553L12.0766 4.70835C11.9736 4.81127 11.8388 4.86273 11.7041 4.86273Z",
			fill: "currentColor"
		})
	]
});
export default SvgGroup;
